import React, { Component } from 'react';
import { Drawer, Table, Select } from 'antd';
import DataTable from './Datatable';
import CreateNewTicket from './CreateNewTicket';
import Header from '../../Common/Component/Header';
import Sidebar from '../../Common/Component/Sidebar';
import { map } from 'lodash';
import {errorHandle} from "../../Common/errorHandle";

const { Option } = Select;

class CaseManagement extends Component {

  state = {
    messageData: [],
    franchiseList: [],
    UserList: [],
    GroupList: [],
    reason: [
    ],
    is_add_new_ticket: false,
    is_message_table: this.props?.history?.location?.state?.table === 'assignedTickets' ? false : true,
    loader: false,
    active_pagination: '15',
    search_value: '',
    message_list_pagination: { current: 1, showSizeChanger: false, pageSize: 15, ordering: "", },
    message_list_filter: {
      user__serviceorder__field_office__uuid: '',
      reason: '',
      assigned_user__uuid: '',
      status: 'open',
      priority: '',
      assigned_group__uuid: ''
    },
    assigned_user: { uuid: '', first_name: '', last_name: '' },
    is_disable_franchise : false,
  }


  componentDidMount = async () => {
    let { message_list_filter, is_message_table } = this.state;
    this.setState({
      loader: true
    })

    //Get User role
    const user = JSON.parse(localStorage.getItem("authUser"));
    var roles = user?.user?.role;
    console.log("Roles : ", roles);
    if (roles.includes(`business_dev_franchiese`) || roles.includes(`accounting_franchiese`) || roles.includes(`franchise_owner`) || roles.includes(`operations_mgr`)) {
      this.setState({ is_disable_franchise: true })
    }

    //get staff user
    this.props.getUserList({ 'limit': 1000, offset: 0, 'ordering': 'first_name', 'is_case_mgmt': true });

    let data = {
      ...message_list_filter,
      limit: 15,
      offset: 0
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);

    //Get All the messages
    if (is_message_table) await this.props.getAllMessages(data)
    else {
      const accessToken = JSON.parse(localStorage.getItem("authUser"))
        ? JSON.parse(localStorage.getItem("authUser")).user
        : "";

      await this.props.getAllMessages({...data, assigned_user__uuid: accessToken.uuid, status: 'open'})
    }

    //Franchise List
    this.props.getFranchiseList();

    //get Group
    this.props.getGroupList({ 'limit': 1000, offset: 0 });

    //get Reasons dropdown
    this.props.getReasonList();
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { message_list_pagination } = this.state;
    //get Message
    if (Object.keys(props.AllMessages.data).length > 0 && props.AllMessages.data !== this.props.AllMessages.data) {

      message_list_pagination.total = props.AllMessages.data.count
      this.setState({
        loader: false,
        messageData: props.AllMessages.data.results
      })
    }

    if (Object.keys(props.AllMessages.errors).length > 0 && props.AllMessages.errors !== this.props.AllMessages.errors) {
      errorHandle(props?.AllMessages?.errors)
      this.setState({
        loader: false,
      })
    }


    //get franchise list
    if (Object.keys(props.FranchiseList.data).length > 0 && props.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: props.FranchiseList.data.results,
        loader: false
      })
    }
    if (Object.keys(props.FranchiseList.errors).length > 0 && props.FranchiseList.errors !== this.props.FranchiseList.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props.FranchiseList.errors)
    }

    // get reason list
    if (Object.keys(props.getReasons.data).length > 0 && props.getReasons.data !== this.props.getReasons.data) {
      this.setState({
        reason: props.getReasons.data.results
      })
    }

    //Get User list
    if (Object.keys(props.UserList.data).length > 0 && props.UserList.data !== this.props.UserList.data) {



      this.setState({
        loader: false,
        UserList: props.UserList.data.results
      })
    }

    if (Object.keys(props.UserList.errors).length > 0 && props.UserList.errors !== this.props.UserList.errors) {
      errorHandle(props.UserList.errors)
      this.setState({
        loader: false,
      })
    }


    //Get Group list
    if (Object.keys(props.GroupList.data).length > 0 && props.GroupList.data !== this.props.GroupList.data) {
      this.setState({
        loader: false,
        GroupList: props.GroupList.data.results
      })
    }

    if (Object.keys(props.GroupList.errors).length > 0 && props.GroupList.errors !== this.props.GroupList.errors) {
      errorHandle(props.GroupList.errors)
      this.setState({
        loader: false,
      })
    }
  }

  //set page limit
  setMessagePageLimit = (custom_limit) => {
    let { search_value, message_list_pagination, message_list_filter } = this.state;
    message_list_pagination = Object.assign(message_list_pagination, { 'current': 1, 'pageSize': custom_limit });


    this.setState({
      message_list_pagination,
      loader: true,
      active_pagination: custom_limit,
      // search_value:''
    })

    let data = {
      offset: 0, limit: custom_limit, ordering: '', search: search_value, ...message_list_filter
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAllMessages(data);
  }

  //Render All Messages Table

  renderAllMessage = () => {
    let { messageData, message_list_pagination, active_pagination } = this.state;
    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          dataSource={messageData}
          pagination={message_list_pagination}
          onChange={this.messageOnChange}
          columns={DataTable.AllMessageList(this)}
          onRow={(record) => {
            return {
              onClick: () => {
                if (record && record.user) {
                  if (record?.user_details?.role?.includes('customer')) {
                    this.props.clearCustomerDetail()
                    this.props.history.push(`/residential/detail`, { query: { 'id': record.user } })
                  } else if (record?.user_details?.role?.includes('commercial_customer')) {
                    this.props.clearCommercialCustomer()
                    this.props.history.push(`/commercial/customer-detail`, { query: { 'id': record.user } })
                  }
                }
                //Set Required  Value in Storage 
                localStorage.setItem('is_ticket_details', JSON.stringify({ record }));
              }
            }
          }}
          className="case_management_table"
          position={false}
          showSorterTooltip={false}

        />


        {messageData.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setMessagePageLimit('15') }}
                className={active_pagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={active_pagination === '30' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('30') }}>30</span>
            </li>
            <li>
              <span
                className={active_pagination === '60' ? 'active' : ''}
                onClick={() => { this.setMessagePageLimit('60') }}>60</span>
            </li>
          </ul> : ''}
      </React.Fragment>

    )
  }

  //Render My messages
  renderMyMessage = () => {
    let { messageData } = this.state;
    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          dataSource={messageData}
          pagination={false}
          columns={DataTable.AllMessageList(this)}
          onChange={this.onAssignToMeChange}
          className="case_management_table"
          position={false}
          onRow={(record) => {
            return {
              onClick: () => {
                if (record && record.user) {
                  if (record?.user_details?.role?.includes('customer')) {
                    this.props.clearCustomerDetail()
                    this.props.history.push(`/residential/detail`, { query: { 'id': record.user } })
                  } else if (record?.user_details?.role?.includes('commercial_customer')) {
                    this.props.clearCommercialCustomer()
                    this.props.history.push(`/commercial/customer-detail`, { query: { 'id': record.user } })
                  }
                }
                //Set Required  Value in Storage 
                localStorage.setItem('is_ticket_details', JSON.stringify({ record }));
              }
            }
          }}
          showSorterTooltip={false}

        />
      </React.Fragment>
    )
  }


  // Message Pagination and ordering
  messageOnChange = (pagination, filters, sorter) => {
    let { message_list_pagination, active_pagination, search_value, message_list_filter } = this.state;


    message_list_pagination = Object.assign(message_list_pagination, { 'current': pagination.current });

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `${sorter.field}-`
    }
    else {
      ordering = ''
    }

    this.setState({
      message_list_pagination,
      loader: true
    })

    let data = {
      offset: (pagination.current * 15) - 15,
      limit: active_pagination,
      ordering,
      ...message_list_filter,
      search: search_value,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAllMessages(data)
  }

  // Message Pagination and ordering
  onAssignToMeChange = (pagination, filters, sorter) => {
    let { search_value } = this.state;

    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).user
      : "";

    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `${sorter.field}-`
    }
    else {
      ordering = ''
    }

    this.setState({
      loader: true
    })

    let data = {
      offset: 0,
      limit: 15,
      ordering,
      search: search_value,
      assigned_user__uuid: accessToken.uuid,
    }
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAllMessages(data)
  }

  //Togel New Ticket Drawer
  newTicketToggle = (key) => {
    this.setState({
      is_add_new_ticket: key
    })
  }

  // Change The Tab
  switchTab = (type) => {
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).user
      : "";

    let { message_list_pagination, message_list_filter } = this.state;

    if (type) {
      message_list_pagination = Object.assign(message_list_pagination, {
        showSizeChanger: false, pageSize: 15, ordering: ""
      })
      message_list_filter = Object.assign(message_list_filter, {
        user__serviceorder__field_office__uuid: '',
        reason: '',
        assigned_user__uuid: '',
        status: 'open',
        priority: '',


      })
      let data = {
        ...message_list_filter,
        limit: 15,
        offset: 0,
        // assigned_user__uuid: accessToken.uuid
      }
      data.status = 'open';
      this.props.getAllMessages(data);

      this.setState({
        loader: true,
        is_message_table: type,
        message_list_pagination,
        search_value: '',
        message_list_filter,
        active_pagination: '15'
      });
    }
    else {
      let data = {
        ...message_list_filter,
        limit: 15,
        offset: 0,
        assigned_user__uuid: accessToken.uuid
      }

      data.status = 'open';

      Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
      this.props.getAllMessages(data);

      message_list_filter = Object.assign(message_list_filter, {
        user__serviceorder__field_office__uuid: '',
        reason: '',
        status: 'open',
        priority: '',
        assigned_user__uuid: accessToken.uuid
      })

      this.setState({
        is_message_table: type,
        message_list_filter,
        loader: true,
        search_value: '',
        assigned_user: {
          uuid: accessToken.uuid,
          first_name: accessToken.first_name,
          last_name: accessToken.last_name
        }
      });
    }


  }

  // message filter
  messageFilterChange = (e, type) => {
    let { message_list_filter, active_pagination, message_list_pagination } = this.state;
    message_list_filter = Object.assign(message_list_filter, { [type]: e, });
    message_list_pagination = Object.assign(message_list_pagination, { 'current': 1 })
    this.setState({
      message_list_filter,
      message_list_pagination,
      loader: true
    })

    let data = {
      ...message_list_filter,
      limit: active_pagination,
      offset: (message_list_pagination.current * 15) - 15,
    }
    // delete data.mess
    Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
    this.props.getAllMessages(data)
  }


  //Render Filter
  renderFilter = () => {
    let { franchiseList, message_list_filter, reason, UserList,
      is_message_table, assigned_user, active_pagination,
      message_list_pagination, GroupList, is_disable_franchise } = this.state;
    var input = 100; //input any number
    var len = input.toString().length;
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).user
      : "";

    return (
      <React.Fragment>
        {!is_message_table ?
          <div className="fitem">
            <span style={{ fontSize: '13px', color: ' #297C78', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                this.setState({
                  message_list_filter: {
                    user__serviceorder__field_office__uuid: '',
                    reason: '',
                    assigned_user__uuid: accessToken.uuid,
                    status: '',
                    priority: ''
                  },
                  assigned_user: {
                    uuid: accessToken.uuid,
                    first_name: accessToken.first_name,
                    last_name: accessToken.last_name
                  }
                })
                let data = {
                  limit: active_pagination,
                  offset: (message_list_pagination.current * 15) - 15,
                  assigned_user__uuid: accessToken.uuid
                }
                // delete data.mess
                Object.keys(data).forEach((key) => (data[key] === null || data[key] === '') && delete data[key]);
                this.props.getAllMessages(data);
              }}

            >Clear All Filters</span>
          </div> : ''}


        <div className="fitem">
          <Select
            defaultValue=""
            value={message_list_filter.user__serviceorder__field_office__uuid}
            onChange={(e) => {
              this.messageFilterChange(e, 'user__serviceorder__field_office__uuid')
              this.messageFilterChange('', 'assigned_group__uuid')
              this.props.getGroupList({field_office__uuid: e, 'limit': 15, offset: 0 })
            }}
            dropdownClassName="md-filter"
            disabled={is_disable_franchise ? true : false}
            className="filter_ant_select filter_by_franchise swhite ">
            <Option value="">All Franchise</Option>
            {map(franchiseList, (item, i) => {
              return (
                <Option key={i} value={item.uuid}><span className="pre_digit">{('000000000000000' + parseInt(i + 1)).slice(-len)}</span> {item.name}</Option>
              )
            })}
          </Select>
        </div>

        <div className="fitem">
          <Select
            defaultValue=""
            value={message_list_filter.reason}
            onChange={(e) => {
              this.messageFilterChange(e, 'reason')
            }}
            dropdownClassName="md-filter"
            className="filter_ant_select filter_by_disposition swhite ">
            <Option value="">All <span className="pre_digit">Disposition</span> </Option>
            {
              map(reason, (item, i) => {
                return (
                  <Option key={i} value={item?.dis_name}>{item?.reason}</Option>
                )
              })
            }

          </Select>
        </div>

        {!is_message_table ?
          <div className="fitem">
            <Select
              showSearch
              showArrow={true}
              filterOption={false}
              notFoundContent={null}
              defaultValue=""
              // value={message_list_filter.assigned_user__uuid}
              // onChange={(e) => { this.messageFilterChange(e, 'assigned_user__uuid') }}

              onChange={(e, i) => {
                this.messageFilterChange(e.key, 'assigned_user__uuid')

                this.setState({
                  assigned_user: { uuid: e.key, first_name: i.children.length > 0 ? i.children[0] : '', last_name: i.children.length > 0 ? i.children[2] : '' }
                })
              }}
              value={{ value: assigned_user.uuid || undefined, label: `${assigned_user.first_name} ${assigned_user.last_name}` }}
              labelInValue



              onSearch={(e) => { this.props.getUserList({ 'limit': 1000, 'search': e, 'ordering': 'first_name', 'is_case_mgmt': true }) }}
              onBlur={() => { this.props.getUserList({ 'offset': 0, 'limit': 1000, 'ordering': 'first_name', 'is_case_mgmt': true }); }}
              dropdownClassName="xs-filter"
              className="filter_ant_select  swhite ">
              <Option value="">All</Option>
              {
                map(UserList, (item, i) => {
                  return (
                    <Option value={item.uuid} key={i}>{item.first_name} {item.last_name} </Option>
                  )
                })
              }
            </Select>
          </div>
          : ''}

        <div className="fitem">
          <Select
            showSearch
            showArrow={true}
            filterOption={false}
            notFoundContent={null}
            defaultValue=""
            onChange={(e) => {
              this.messageFilterChange(e, 'assigned_group__uuid')
            }}
            value={message_list_filter?.assigned_group__uuid}

            onSearch={(e) => { this.props.getGroupList({ 'search': e }) }}
            // onBlur={() => { this.props.getGroupList({ 'offset': 0, 'limit': 15 }); }}
            dropdownClassName="xs-filter"
            className="filter_ant_select filter_by_group swhite">
            <Option value="">All</Option>
            {
              map(GroupList, (item, i) => {
                return (
                  <Option value={item.uuid} key={i}>{item.name}</Option>
                )
              })
            }
          </Select>
        </div>


        <div className="fitem">
          <Select
            defaultValue=""
            value={message_list_filter.status}
            onChange={(e) => {
              this.messageFilterChange(e, 'status')
            }}
            dropdownClassName="xs-filter"
            className="filter_ant_select filter_by_status swhite ">
            <Option value="">All <span className="pre_digit">Status</span></Option>
            <Option key='open' value="open">Open Tickets</Option>
            <Option key='closed' value="closed">Closed Tickets</Option>


          </Select>
        </div>

        <div className="fitem">
          <Select
            defaultValue=""
            value={message_list_filter.priority}
            onChange={(e) => {
              this.messageFilterChange(e, 'priority')
            }}
            dropdownClassName="sm-filter"
            className="filter_ant_select filter_by_priority swhite ">
            <Option value="">All <span className="pre_digit">Priority</span></Option>
            <Option key="4" value="4">Standard Priority</Option>
            <Option key="3" value="3">High Priority</Option>

          </Select>
        </div>

        <div className="fitem">
          <button
            onClick={() => {
              this.newTicketToggle(true)
            }}
            className="btn btn-warning"
          >Create New Ticket</button>

        </div>

      </React.Fragment >
    )
  }

  // Search Ticket
  searchTicket = (e) => {
    const accessToken = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser")).user
      : "";
    let { is_message_table } = this.state;
    const search_value = e.target.value;
    this.setState({
      search_value: e.target.value
    }, () => {
      if (is_message_table) {
        if (search_value?.length >= 3 || search_value?.length === 0) {
          setTimeout(() => this.props.getAllMessages({ 'q': search_value, 'offset': 0, 'limit': 15, }), 1000)
        }
      } else {
        if (search_value?.length >= 3 || search_value?.length === 0) {
          // Call Assgign me API
          setTimeout(() => this.props.getAllMessages({ 'q': search_value, 'offset': 0, 'limit': 15, assigned_user__uuid: accessToken.uuid }), 1000)
        }
      }
    })
  }

  render() {
    let { is_add_new_ticket, loader, is_message_table, search_value } = this.state;
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header

            placeholder="Ticket Name, Customer Name"
            search_value={search_value}
            onSearch={(e) => { this.searchTicket(e) }}
            onEnter={(e) => this.setState({search_value: '', loader: true}, () => this.searchTicket(e))}
          />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />
          <div className="container">
            <div className="filter_wrapper">
              <div className="left_side">
                <ul className="tabs">
                  <li className={is_message_table ? 'active' : ''} onClick={() => { this.switchTab(true); }}>
                    <span>ALL TICKETS</span>
                  </li>
                  <li className={is_message_table ? '' : 'active'} onClick={() => { this.switchTab(false); }}>
                    <span>ASSIGNED TO ME</span>
                  </li>
                </ul>
              </div>

              <div className="right_side">
                <div className="form-group flex ai-center fltr-txt flex-wrap justify-content-end">
                  {
                    this.renderFilter()
                  }
                </div>
              </div>

            </div>

            <div className="data">
              {
                is_message_table ? this.renderAllMessage() : this.renderMyMessage()
              }

            </div>

          </div>
        </div>

        {/* Create New ticketFilter */}
        <Drawer
          visible={is_add_new_ticket}
          width={'690'}
          closable={false}
          className="drawer-wrapper create_ticket_drawer"
        >

          <CreateNewTicket
            {...this.props}
            is_message_table={is_message_table}
            newTicketToggle={() => { this.newTicketToggle() }}
          />


        </Drawer>

        {
          loader ?
            <div className='loader_wrapper'>
              < div className='loader07' ></div >
            </div >
            : ''
        }
      </div>
    );
  }
}

export default CaseManagement;